import styles from './TemplateBlockContent.module.css';
import { SanitizeHTML } from '@shared/Helpers/SanitizeHTML';
import React from 'react';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import classNames from 'classnames';

const TEXT_FONT_STYLE = {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '20px',
} as const;

interface TemplateBlockContentProps {
    block: Element;
    index: number;
}

export const TemplateBlockContent: React.FC<TemplateBlockContentProps> = ({
    block,
    index,
}) => {
    const [isDesktop] = useMediaType();
    const isOdd = index % 2 !== 0;

    const image = block.querySelector('img');
    const text = block.querySelector('.image-text');
    const hasImage = Boolean(image);
    const hasText = Boolean(text?.innerHTML && text.innerHTML.trim());

    if (!isDesktop && text) {
        text.querySelectorAll('div').forEach(div => {
            if (
                div.childNodes.length === 1 &&
                div.firstChild?.nodeName === 'BR'
            ) {
                div.remove();
            }
        });
    }

    const getMediaClass = () => {
        if (hasImage && !hasText) return styles.fullWidthImage;
        if (!hasImage && hasText)
            return `${styles.fullWidthText} ${styles.blogTextBlockOnly}`;
        if (hasImage && hasText) return isOdd ? styles.odd : styles.even;
        return '';
    };

    const getTextBlockClass = () => {
        if (hasImage) return isOdd ? styles.blockEven : styles.blockOdd;
        return styles.blogTextBlockOnly;
    };

    const getParagraphClass = () => {
        if (hasImage) return styles.blogTextBlockP;
        return `${styles.blogTextBlockP} ${styles.blogTextBlockPOnly}`;
    };

    return (
        <div className={styles.blogSection}>
            <div
                className={classNames(styles.blogMediaSection, getMediaClass())}
            >
                {hasImage && (
                    <img
                        className={styles.blogMediaImg}
                        src={image!.getAttribute('src')!}
                        alt="Block"
                    />
                )}

                {hasText && (
                    <div
                        className={classNames(
                            styles.blogTextBlock,
                            getTextBlockClass()
                        )}
                    >
                        <p
                            className={getParagraphClass()}
                            style={TEXT_FONT_STYLE}
                            dangerouslySetInnerHTML={{
                                __html: SanitizeHTML(text!.innerHTML),
                            }}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
